import styles from './Roles.module.css';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { Role } from './Role';

export const RolesList = ({ readOnly, certifications, roles, onAddRole, onUpdateRole, onRemoveRole, onCancel }) => {
    const handleAddRole = (role) => {
        onAddRole(role);
    };

    const handleUpdateRole = (role) => {
        onUpdateRole(role);
    };

    const handleRemoveRole = (role) => {
        onRemoveRole(role);
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <div className={ styles.roles }>
            <Grid container spacing={ 1 } sx={ { width: '100%' } }>
                <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ readOnly ? 3 : 2 } display='flex' alignItems='center'>
                    <Typography variant="title">Role</Typography>
                </Grid>

                <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ readOnly ? 4 : 3 } display='flex' alignItems='center'>
                    <Typography variant="title">Certification</Typography>
                </Grid>

                <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ readOnly ? 2 : 2 } display='flex' alignItems='center'>
                    <Typography variant="title">Required</Typography>
                </Grid>

                <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ readOnly ? 3 : 3 } display='flex' alignItems='center'>
                    <Typography variant="title">Lead</Typography>
                </Grid>

                { !readOnly &&
                    <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 2 } display='flex' justifyContent='center' alignItems='center'>
                        <Typography variant="title">Actions</Typography>
                    </Grid>
                }
            </Grid>

            { roles.map(f => {
                return <Role key={ f.id } role={ f } readOnly={ readOnly } certifications={ certifications } onAddRole={ handleAddRole } onUpdateRole={ handleUpdateRole } onRemoveRole={ handleRemoveRole } onCancel={ handleCancel } />;
            }) }
        </div>
    );
};